
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class AutoKeyGenDialog extends Serenity.EntityDialog<AutoKeyGenRow, any> {
        protected getFormKey() { return AutoKeyGenForm.formKey; }
        protected getIdProperty() { return AutoKeyGenRow.idProperty; }
        protected getLocalTextPrefix() { return AutoKeyGenRow.localTextPrefix; }
        protected getService() { return AutoKeyGenService.baseUrl; }

        protected form = new AutoKeyGenForm(this.idPrefix);

        protected onSaveSuccess(response: Serenity.SaveResponse): void {

            // check that this is an insert
            if (this.isNew) {
                AutoKeyGenService.Retrieve(<any>{
                    EntityId: response.EntityId
                }, resp => {
                    Q.information(
                        "SerialKey Successfully Generated, SerialKey : " + resp.Entity.SerialKey,
                        () => {
                            Q.notifySuccess("SerialKey Successfully Generated, SerialKey : " + resp.Entity.SerialKey);
                        },
                        {
                            title: 'Auto SerialKey Generation'
                        });
                });
            }
        }
    }
}